export const classes = {
  wrapper: 'text-center',
  title: 'mb-2 text-[20px] font-extrabold text-taupe-3 dark:text-mauve-1',
  subtitle: 'text-sm leading-[1.6] text-taupe-2 dark:text-mauve-2',
};
